// /src/store/networkManagment/actions.ts

import { DetailledIpAddressInformations } from '../../dataTypes/networkManagment/types';
import {
  FETCH_ALL_IPS_DETAILS_REQUEST,
  FETCH_ALL_IPS_DETAILS_SUCCESS,
  FETCH_ALL_IPS_DETAILS_FAILURE,
  FETCH_ONE_IP_DETAILS_REQUEST,
  FETCH_ONE_IP_DETAILS_SUCCESS,
  FETCH_ONE_IP_DETAILS_FAILURE,
  NetworkActionTypes
} from './types';
import { Dispatch } from 'redux';
import { getDetailledIpAddressInformationsWithIp, getDetailledIpAddressInformations } from '../../backendServices/networkManagment/api';
import { RootState } from '../generalReducer';
import { store } from '../store'; // Assurez-vous d'importer votre store Redux

export const fetchDetailledIpAddressInformationsByIp = (ipAddress: string, userId?: number) => async (dispatch: Dispatch<NetworkActionTypes>, getState: () => RootState) => {
  const state = getState();
  const lastFetched = state.networkInformationsReducer.lastFetchTimestamp;
  const ipDetails = state.networkInformationsReducer.ipDetails;
  const cacheDuration = 10 * 60 * 1000; // 10 minutes en millisecondes

  dispatch({ type: FETCH_ONE_IP_DETAILS_REQUEST });

  if (ipDetails.has(ipAddress) && (Date.now() - lastFetched < cacheDuration)) {
    // Si les données sont dans le cache et encore valides, on les renvoie
    return;
  }

  try {
    const response = await getDetailledIpAddressInformationsWithIp(ipAddress, userId);

    if (response.code === 1) {
      dispatch({ type: FETCH_ONE_IP_DETAILS_SUCCESS, payload: response.payload });
    } else {
      dispatch({ type: FETCH_ONE_IP_DETAILS_FAILURE, payload: response.comment });
    }
  } catch (error: unknown) {
    dispatch({ type: FETCH_ONE_IP_DETAILS_FAILURE, payload: (error as Error).message || 'Une erreur inconnue est survenue.' });
  }
};

export const fetchDetailledIpAddressInformations = () => async (dispatch: Dispatch<NetworkActionTypes>, getState: () => RootState) => {
  const state = getState();
  const lastFetched = state.networkInformationsReducer.lastFetchTimestamp;
  const cacheDuration = 10 * 60 * 1000; // 10 minutes

  if (lastFetched && (Date.now() - lastFetched < cacheDuration)) {

    return; // Les données sont encore valides
  }

  dispatch({ type: FETCH_ALL_IPS_DETAILS_REQUEST });

  try {
    const response = await getDetailledIpAddressInformations();

    if (response.code === 1) {
      dispatch({ type: FETCH_ALL_IPS_DETAILS_SUCCESS, payload: response.payload });
    } else {
      dispatch({ type: FETCH_ALL_IPS_DETAILS_FAILURE, payload: response.comment });
    }
  } catch (error: unknown) {
    dispatch({ type: FETCH_ALL_IPS_DETAILS_FAILURE, payload: (error as Error).message || 'Une erreur inconnue est survenue.' });
  }
};


export const retrieveDetailledIpAddressInformationsByIp = async (ipAddress: string, userId?: number): Promise<DetailledIpAddressInformations | null> => {
  const { dispatch, getState } = store;
  const state = getState();
  const ipDetails = state.networkInformationsReducer.ipDetails;

  if (ipDetails.has(ipAddress)) {
    const ipDetail = ipDetails.get(ipAddress);
    return ipDetail ?? null; // Retourne les informations si présentes dans le cache, sinon retourne null
  }

  await dispatch(fetchDetailledIpAddressInformationsByIp(ipAddress, userId)); // Met à jour le store avec les informations de l'adresse IP
  const updatedState = getState();
  return updatedState.networkInformationsReducer.ipDetails.get(ipAddress) ?? null; // Retourne les informations après mise à jour du store
};

export const retrieveDetailledIpAddressInformations = async (): Promise<DetailledIpAddressInformations[]> => {
  const { dispatch, getState } = store;
  const state = getState();
  const ipDetails = state.networkInformationsReducer.ipDetails;

  if (ipDetails.size > 0) {
    return Array.from(ipDetails.values()); // Retourne la liste des informations si présentes dans le cache
  }

  await dispatch(fetchDetailledIpAddressInformations()); // Met à jour le store avec la liste des informations des adresses IP
  const updatedState = getState();
  return Array.from(updatedState.networkInformationsReducer.ipDetails.values()); // Retourne la liste des informations après mise à jour du store
};
